import { Component, Input, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Address_Interface } from 'src/app/Interface/Address_Interface';
import { KarshnasMasol_Interface } from 'src/app/Interface/KarshnasMasol_Interface';
import { LetterRequestCustomer_Activity } from 'src/app/Interface/LetterRequestCustomer_Activity';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';

@Component({
  selector: 'app-LetterRequestCustomerMissionActivityForm',
  templateUrl: './LetterRequestCustomerMissionActivityForm.component.html',
  styleUrls: ['./LetterRequestCustomerMissionActivityForm.component.scss']
})
export class LetterRequestCustomerMissionActivityFormComponent implements OnInit {

  @Input() inner_Letter_id: number = 0
  @Input() inner_Customer_id: number = 0
  Token: String = ""
  InProccessing: boolean = false

  DataList_KarshnasMasol: Array<KarshnasMasol_Interface> = []
  DataList_Address: Array<Address_Interface> = []


  Selection_KarshnasMasol_Id: String = "0"
  Selection_Address_Id: String = "0"
  can_submit:boolean=false;

  constructor(
    private Customer_Service: CustomerService,
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Read_Customer_Info()
  }


  Read_Customer_Info() {
    this.InProccessing = true
    this.Customer_Service.GetSingle(this.Token, this.inner_Customer_id).subscribe(
      data => {

        this.InProccessing = false
        this.DataList_KarshnasMasol = data['karshnasMasol']
        this.DataList_Address = data['address']
        this.can_submit = data['done']
        

        this.Get_Record()
      }
    )
  }

  Get_Record(){
    this.InProccessing=true
    this.LetterRequestCustomer_Service.GetActivityForm(Number(this.inner_Letter_id),
      this.Token).subscribe(
        data=>{
          this.InProccessing=false
          this.Selection_KarshnasMasol_Id = data['karshnas_masol_id']
          this.Selection_Address_Id = data['address_id']
        }
      )
  }

  OnSubmit(){
    this.InProccessing=true
    this.LetterRequestCustomer_Service.PostActivityForm(
      Number(this.Selection_KarshnasMasol_Id),
      Number(this.Selection_Address_Id),
      Number(this.inner_Letter_id),
      this.Token).subscribe(
        data=>{
          this.InProccessing=false
          this.Alertify_Service.SuccessMessage("The information was saved successfully.")
        }
      )
  }

  returenSelectedAddress(){
    if(this.Selection_Address_Id=="0")
      return ""
    else{
      for(let item of this.DataList_Address)
      {
        if(item.id==Number(this.Selection_Address_Id))
          return item.address
      }
    }
  }

}
